var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile03Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0682 7.00966C15.0682 8.65648 13.6742 10.1249 12 10.1249C10.3258 10.1249 8.93182 8.65648 8.93182 7.00966C8.93182 5.32695 10.3598 3.75 12 3.75C13.6402 3.75 15.0682 5.32695 15.0682 7.00966ZM20.25 16.7779C20.25 17.5917 19.7954 18.4261 18.5056 19.0984C17.191 19.7836 15.0781 20.2502 12 20.2502C8.92186 20.2502 6.80897 19.7836 5.49439 19.0984C4.20459 18.4261 3.75 17.5917 3.75 16.7779C3.75 16.0743 4.38661 15.2069 5.95458 14.4713C7.46298 13.7636 9.59955 13.3056 12 13.3056C14.4005 13.3056 16.537 13.7636 18.0454 14.4713C19.6134 15.2069 20.25 16.0743 20.25 16.7779Z",
    fill: "#A4C7FF",
    stroke: "#065EEA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile03Active);
export default __webpack_public_path__ + "static/media/user-profile-03-active.a1656ec7359113449e816fb0c7c00830.svg";
export { ForwardRef as ReactComponent };